import { render } from "./DefenseTable.vue?vue&type=template&id=b6bdae5c&lang=true"
import script from "./DefenseTable.vue?vue&type=script&lang=js"
export * from "./DefenseTable.vue?vue&type=script&lang=js"
script.render = render

export default script